import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connectedRouterHOC from '../../utils/connectedRouterHOC';
import ExtensionsOfTimeGrid from './extensionsOfTimeGrid';
import extensionsOfTime, { deleteExtensionOfTime, requestExtensionsOfTime, clearExtensionsOfTime } from '../../reducers/extensionsOfTime';
import { requestSeparablePortions } from '../../reducers/separablePortions';
import ContentContainer from '../contentContainer';
import { showModal } from '../../reducers/modal';
import { canView } from '../../selectors/canView';
import { canEdit } from '../../selectors/canEdit';
import PageLayout from '../pageLayout';
import groupBy from 'lodash/groupBy';
import find from 'lodash/find';

class ExtensionsOfTime extends Component {
    constructor(props) {
        super(props);

        this.state = {
			extensionsOfTime: {}
        };

		this.onEditExtensionOfTime = this.onEditExtensionOfTime.bind(this);
		this.onViewExtensionOfTime = this.onViewExtensionOfTime.bind(this);
		this.onDeleteExtensionOfTime = this.onDeleteExtensionOfTime.bind(this);
    }
	static fetchData(dispatch) {
		dispatch(requestExtensionsOfTime());
		dispatch(requestSeparablePortions());
		
	}
	static clearData(dispatch) {
		dispatch(clearExtensionsOfTime());
	}
	componentDidMount() {
		ExtensionsOfTime.fetchData(this.props.dispatch);
	}

	onEditExtensionOfTime = (extensionOfTime) => {
		this.props.history.push(`/extension-of-time/${extensionOfTime.extensionOfTimeId}`);
	}

	onViewExtensionOfTime = (extensionOfTime) => {
		this.props.history.push(`/extension-of-time/${extensionOfTime.extensionOfTimeId}`);
	}
	onDeleteExtensionOfTime(extensionOfTime) {
		this.props.deleteExtensionOfTime(extensionOfTime);
	}

	newExtensionOfTime = () => {
		this.props.history.push('/extension-of-time');
	}

	render() {
		const separablePortions = this.props.separablePortions;

		let Content = null;

		let contractEOTs = []; 
		let spEOTS = [];
		let unmatchedEOTS = [];

		if (this.props.extensionsOfTime && this.props.extensionsOfTime.length > 0) {
			for (let i = 0; i < this.props.extensionsOfTime.length; i++) {
				let isMatched = false;
				const eot = this.props.extensionsOfTime[i];
				if (eot.appliesToEntireContract) {
					contractEOTs.push(eot);
					isMatched = true;
				}
				for (let j = 0; j < eot.separablePortions.length; j++) {
					let spEOT = eot.separablePortions[j];
					let sp = find(spEOTS, sp2 => sp2.separablePortionId === spEOT.separablePortionId);
					if (!sp) {
						sp = {
							separablePortionId: spEOT.separablePortionId,
							name: spEOT.name,
							extensionsOfTime: []
						};
						spEOTS.push(sp);
					}
					sp.extensionsOfTime.push(eot);
					isMatched = true;
				}

				if (!isMatched) {
					unmatchedEOTS.push(eot);
				}
			}
		}

		let eotGrids = [];
		if (contractEOTs.length > 0 || spEOTS.length == 0) {
			eotGrids.push(
				<div>
					{spEOTS.length > 0 && <h3>Entire Contract</h3>}
					<ExtensionsOfTimeGrid 
						extensionsOfTime={contractEOTs} 
						onEditExtensionOfTime={this.onEditExtensionOfTime} 
						onDeleteExtensionOfTime={this.onDeleteExtensionOfTime} 
						onViewExtensionOfTime={this.onViewExtensionOfTime} 
						canView={this.props.canView}
						canEdit={this.props.canEdit}
					/>
				</div>
			);
		}
		for (let i = 0; i < spEOTS.length; i++) {
			const spEOT = spEOTS[i];
			eotGrids.push(
				<div>
					<h3>{spEOT.name}</h3>
					<ExtensionsOfTimeGrid 
						separablePortionId={spEOT.separablePortionId}
						extensionsOfTime={spEOT.extensionsOfTime} 
						onEditExtensionOfTime={this.onEditExtensionOfTime} 
						onDeleteExtensionOfTime={this.onDeleteExtensionOfTime} 
						onViewExtensionOfTime={this.onViewExtensionOfTime} 
						canView={this.props.canView}
						canEdit={this.props.canEdit}
					/>
				</div>
			);
		}
		if (unmatchedEOTS.length > 0) {
			eotGrids.push(
				<div>
					<h3>Unmatched Extensions of Time</h3>
					<ExtensionsOfTimeGrid 
						extensionsOfTime={unmatchedEOTS} 
						onEditExtensionOfTime={this.onEditExtensionOfTime} 
						onDeleteExtensionOfTime={this.onDeleteExtensionOfTime} 
						onViewExtensionOfTime={this.onViewExtensionOfTime} 
						canView={this.props.canView}
						canEdit={this.props.canEdit}
					/>
				</div>
			);
		}
		

		Content = 
			<>
				{eotGrids}
			</>;

		return (
<PageLayout
	title="Extensions of Time"
	isLoading={this.props.isLoading}
	rememberScrollPosition={true}
	actions={
		this.props.canEdit ? 
		[
			{
				label: 'New Extension Of Time',
				onClick: this.newExtensionOfTime
			}
		] : []
	}
	content={
		<ContentContainer>
			{Content}
		</ContentContainer>
	}
/>
		);
	}
}

ExtensionsOfTime.propTypes = {
	dispatch: PropTypes.func.isRequired,
	extensionsOfTime: PropTypes.array,
	deleteExtensionOfTime: PropTypes.func.isRequired,
	canView: PropTypes.bool.isRequired,
	canEdit: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired
};

ExtensionsOfTime.defaultProps = {
	extensionsOfTime: []
};

const mapStateToProps = (state) => ({
	extensionsOfTime: state.extensionsOfTime.extensionsOfTime,
	separablePortions: state.separablePortions.separablePortions,
	canView: canView(state, 'ViewExtensionOfTime'),
	canEdit: canEdit(state, 'EditExtensionsOfTime'),
	isLoading: state.extensionsOfTime.isLoading
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	deleteExtensionOfTime: (extensionOfTime) => {
		dispatch(showModal('CONFIRM_DELETE', {
			title: 'Delete?',
			message: 'Are you sure you wish to delete this EOT?',
			onOk: () => {
				dispatch(deleteExtensionOfTime(extensionOfTime));
			}
		}));
	}
});

export default connectedRouterHOC(
	mapStateToProps,
	mapDispatchToProps
)(ExtensionsOfTime);
